import React, { FC } from 'react';
import styled from 'styled-components';
import { CurrencyText } from '@components/currency';
import { SectorColors } from '../../../../utils';
import { useFactorControl } from '../../../../hooks';

interface IFactorControl {
  color: SectorColors;
  factor: string;
  currentAmount?: number;
  onClick?: () => void;
}

export const FactorControl: FC<IFactorControl> = ({ onClick, color, factor, currentAmount }) => {
  const { amount, disabled } = useFactorControl(color);

  return (
    <Container
      type="button"
      disabled={disabled}
      className={`${amount > 0 ? 'active' : ''} ${color}`}
      onClick={onClick}
    >
      <span className="amount">
        {!!amount && (
          <span>
            <CurrencyText value={amount} />
          </span>
        )}
        {!!currentAmount && (
          <span>
            {!!amount && '+ '}
            <CurrencyText value={currentAmount} />
          </span>
        )}
      </span>
      <span className="bid-coefficient">
        x<span>{factor}</span>
      </span>
    </Container>
  );
};

const Container = styled.button`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;
  padding: 0.375rem 0.75rem;
  border-radius: var(--size-radius-m);
  transition: all 300ms var(--transition-ease-out);

  &:disabled {
    opacity: 0.3;
  }

  &.blue {
    background: var(--x50-blue-fill);
    border: 0.125rem solid var(--x50-blue-stroke);

    &.active {
      background: var(--x50-blue-stroke);
    }
  }

  &.red {
    background: var(--x50-red-fill);
    border: 0.125rem solid var(--x50-red-stroke);

    &.active {
      background: var(--x50-red-stroke);
    }
  }

  &.green {
    background: var(--x50-green-fill);
    border: 0.125rem solid var(--x50-green-stroke);

    &.active {
      background: var(--x50-green-stroke);
    }
  }

  &.gold {
    background: var(--x50-gold-fill);
    border: 0.125rem solid var(--x50-gold-stroke);

    &.active {
      background: var(--x50-gold-stroke);
    }
  }

  & > span {
    font-weight: bold;
    letter-spacing: 0.084px;
    font-size: 0.8125rem;
    line-height: 1rem;
    color: var(--color-white);
  }

  & .amount {
    & span {
      font-weight: inherit;
      letter-spacing: inherit;
      font-size: inherit;
      line-height: inherit;

      &:not(:first-of-type) {
        margin-left: 0.25rem;
      }
    }
  }

  & .bid-coefficient {
    letter-spacing: 2px;

    & span {
      font-weight: bold;
      font-size: 1.5rem;
      line-height: 1.75rem;
    }
  }
`;
